import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { UploadZipService } from 'src/app/services/upload-zip/upload-zip.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { XlsxViewComponent } from 'src/app/shared/xlsx-view/xlsx-view.component';
import { ChannelModel } from '../../shared/models/channel';
import { ExcelModel, GeographyModel } from '../../shared/models/geography';
import { RegionModel } from '../../shared/models/region';
import { UpdateMobileModel, UserDetailModel, UserMobileUpdateModel } from '../../shared/models/User';
import { ChannelProvider } from '../../shared/providers/channel.provider';
import { GeographyProvider } from '../../shared/providers/geography.provider';
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { RegionProvider } from '../../shared/providers/region.provider';
import { RolesProvider } from '../../shared/providers/roles.provider';
import { StateProvider } from '../../shared/providers/state.provider';

@Component({
  selector: 'app-create-mystery-shopper',
  templateUrl: './create-mystery-shopper.component.html',
  styleUrls: ['./create-mystery-shopper.component.scss']
})
export class CreateMysteryShopperComponent implements OnInit {


  page = 1;
  users: UserDetailModel[];
  regions: RegionModel[];
  geography: GeographyModel[];
  channels: ChannelModel[];
  roles: any[];
  cities: any[];
  states: any[];
  tempOptionModel: any;
  excel: ExcelModel = new ExcelModel();
  excelFileName: string;
  StatesfilterByRegion: any[];
  getPaginationCount;
  /************/

  filteredDetails: any = {
    search_string: "",
    regions: [],
    user_roles: [],
    geography: [],
    states: [],
    city: [],
  };

  filteredDetailsForApi: any = {
    search_string: "",
    regions: "",
    user_roles: "",
    geography: "",
    states: "",
    city: "",
  };

  constructor(private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    public exportExcelService: ExportExcelService,
    public adminDataProvider: AdminDataProvider,
    public regionProviders: RegionProvider,
    public stateProviders: StateProvider,
    public channelProviders: ChannelProvider,
    public geoProviders: GeographyProvider,
    private rolesProvider: RolesProvider,
    public toast: ToastClientService,
    private xlsx: XlsxService,
    public alertService: AlertService,
    private uploadFile: UploadZipService) {

    this.uploadFile.currentMessage.subscribe((message) => {
      if (message.status == "success") {
        this.getAllUsers(this.page, this.filteredDetailsForApi);
      }
    });
  }

  ngOnInit() {
    this.getAllUsers(this.page, this.filteredDetailsForApi);
  }

  ngDoCheck() {
    this.regions = this.regionProviders.regions;
    this.channels = this.channelProviders.channels;
    this.geography = this.geoProviders.geography;
    this.roles = this.rolesProvider.roles;
    this.states = this.stateProviders.state;
  }

  getAllUsers(pageNumber, data) {
    this.apiService
      .getHeaders(
        this.apiConfig.allUsers +
        "?page=" +
        pageNumber +
        "&search_string=" +
        data.search_string +
        "&geographical_id=" +
        data.geography +
        "&user_role_id=" +
        7 +
        "&state_code=" +
        data.states +
        "&region_id=" +
        data.regions +
        "&city=" +
        data.city
      )
      .subscribe(
        (res: any) => {
          this.getPaginationCount = res.headers.get(
            "X-Pagination-Total-Count"
          );
          this.users = res.body.data;
          if (this.users.length > 0) {
            this.users.forEach((i) => {
              i.isEdit = false;
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  /***********/

  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }
  closeoptionModel() {
    this.tempOptionModel.close();
  }
  uploadXlsx(eve) {
    if (eve.target.files) {
      this.excelFileName = eve.target.files[0].name;
    }
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView(res);
    });
  }
  xlsxView(data) {
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        console.log("XlsxViewComponent::", result);
        if (result.length > 0) {
          this.excel.excel_data = result;
          this.enableUploadDiv(this.excel);
        }
      },
      (reason) => { }
    );
  }

  enableUploadDiv(data) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: this.apiConfig.importMysteryExcelUser,
      module: "Users",
      zip: "no",
      excelname: this.excelFileName,
    });
  }

  importAllUsers(data) {
    this.apiService.post(this.apiConfig.importExcelUser, data).subscribe(
      (res: any) => {
        this.toast.Success("Data imported Successfully");
        this.getAllUsers(this.page, this.filteredDetailsForApi);
      },
      (err) => {
        this.toast.Error("Failed to Update");
        console.log(err);
      }
    );
  }

  downloadExcel() {
    this.exportExcelService.exportUserExcel(
      this.geography,
      this.channels,
      this.regions,
      this.roles,
      this.states,
      this.cities
    );
  }

  filterListOfRecords() {
    try {
      this.filteredDetailsForApi.states = this.filteredDetails.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.city = this.filteredDetails.city
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.regions = this.filteredDetails.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.geography = this.filteredDetails.geography
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.user_roles = this.filteredDetails.user_roles
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.search_string = this.filteredDetails.search_string;
      this.getAllUsers(this.page, this.filteredDetailsForApi);
    } catch (error) { }
  }

  /* Fillter section start */
  async selectedItem(data, serviceId) {
    switch (serviceId) {
      case 1: // roles
        this.filteredDetails.user_roles = await data;
        break;
      case 2: // State
        this.filteredDetails.states = await data;
        break;
      case 3: // city
        this.filteredDetails.city = await data;
        break;
      case 4: // resions
        this.filteredDetails.regions = await data;
        this.StatesfilterByRegion = [];
        let item = data;
        item.forEach((element) => {
          this.StatesfilterByRegion.push(
            ...this.states.filter(
              (s) => s.region_id == element.id && s.state_year == 2021
            )
          );
        });
        break;
      case 5: // geography
        this.filteredDetails.geography = await data;
        break;
      default:
        break;
    }
  }

  paginationClick(pageNumber) {
    this.getAllUsers(pageNumber, this.filteredDetailsForApi);
    this.page = pageNumber;
  }

  userMobile: UserMobileUpdateModel[] = [];

  editRowUser(index, item: UserDetailModel) {
    item.isEdit = true;
    console.log(item);
  }

  updateDataUser(index, item: UserDetailModel, type) {
    this.userMobile = [];
    item.isEdit = false;
    let data: UserMobileUpdateModel = new UserMobileUpdateModel();
    data.mobile = item.username;
    data.user_id = item.user_id;
    this.userMobile.push(data);
    let updateData: UpdateMobileModel = new UpdateMobileModel();
    updateData.userexcelupload = 0;
    updateData.userupdate = this.userMobile;
    this.updateUserMobileNumber(updateData, type, index);
  }

  updateUserMobileNumber(item: UpdateMobileModel, type, index) {
    this.apiService.post(this.apiConfig.UpdateUserMobile, item).subscribe(
      (res: any) => {
        if (res.status == 201 || res.status == 200) {
          if (type == "edit") {
            this.toast.Success("Updated successfully");
            this.alertService.success(res.body.data.message);
            this.clearSuccess();
          }
        }
      },
      (err) => {
        console.log(err);
        this.getAllUsers(this.page, this.filteredDetailsForApi);
      }
    );
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

}
